import { IExtractedFields } from '../../recording/RecordingState';

/**
 * Keys that are displayed in the Bea comment bubble's fields card, in display order.
 * The single source of truth: BeaCommentBubble derives its row config from this list,
 * so a key added here (and only here) gets both counted for visibility and rendered.
 */
export const DISPLAYED_FIELD_KEYS = [
    'careRecipientName',
    'relationship',
    'diagnoses',
    'allergies',
    'medications',
    'address',
    'supportsAdded',
    'supportsUpdated',
    'dob',
    'contactInfo',
] as const satisfies readonly (keyof IExtractedFields)[];

export type IDisplayedFieldKey = (typeof DISPLAYED_FIELD_KEYS)[number];

/** Returns true if the extracted fields contain at least one non-empty displayed field. */
export const hasExtractedFields = (fields?: IExtractedFields): boolean => {
    if (!fields) {
        return false;
    }
    return DISPLAYED_FIELD_KEYS.some(key => {
        const value = fields[key];
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        return !!value;
    });
};
